import { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {}

const AngleIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="15"
      height="20"
      viewBox="0 0 15 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="angle icon">
      {/* <title>angle icon</title> */}
      <path
        d="M14.082 8.49614L8.14449 14.086C7.96481 14.2891 7.73043 14.375 7.49996 14.375C7.26949 14.375 7.0359 14.2896 6.85543 14.1187L0.917929 8.49614C0.541757 8.13677 0.526132 7.54302 0.881211 7.16802C1.23785 6.78911 1.83355 6.77739 2.20699 7.13286L7.49996 12.1446L12.7929 7.12896C13.1664 6.77372 13.7597 6.78716 14.1187 7.16558C14.4726 7.54302 14.457 8.13677 14.082 8.49614Z"
        fill={props.fill || "currentColor" || "#B0B0B8"}
      />
    </svg>
  );
};

export default AngleIcon;
